//*** Form  */
//** UR: http://localhost:3000/Customer/10552/Order/11232
// ** "Single Order Information (view here - add/edit another component (OrderAddUpdate))"
//**

import {
  Fragment,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  createRef,
  forwardRef,
} from "react";
// import { Fragment, useState, useEffect } from "react";
// React Notification
import { NotificationManager } from "react-notifications";
import orderServices from "../../services/orderServices";
import OrderAddUpdate from "./../Order/OrderAddUpdate";
import Invoice from "./Invoice";
//** get actions from store */
import { useSelector, useDispatch } from "react-redux";
import {
  addOrderInfo,
  updateOrderInfoModeStore,
} from "./../../slice/orderSlice";
import { ToWords } from "to-words";
import OrderMakingPrint from "./OrderMakingPrint";
import ReactToPrint from "react-to-print";
import commonServices from "../../Utils/commonServices";
import { updateOrder_IsSMSSent } from "./../../slice/orderSlice";

// var converter = require('number-to-words');
// converter.toWords(13);

const OrderDetailInformation = (props) => {
  const printableRef = useRef(null);

  var converter = require("number-to-words");

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: false,
      ignoreZeroCurrency: false,
      doNotAddOnly: false,
      currencyOptions: {
        // can be used to override defaults for the selected locale
        name: "Taka",
        plural: "Taka",
        symbol: "tk",
        fractionalUnit: {
          name: "Poisa",
          plural: "Poisa",
          symbol: "",
        },
      },
    },
  });

  //*** Store */
  const dispatch = useDispatch();
  //Get state from store
  const {
    customerStore,
    customerInfoModeStore,
    customerGUIDStore,
    orderStore,
    orderInfoModeStore,
    orderGUIDStore,
    orderProductItemStore,
    orderItemsWithMeasurementStore,
    isLoadingStore,
  } = useSelector((state) => state.order);

  // (1) Load Order and Show Information
  const [order, setOrder] = useState();
  const [isViewMode, setIsViewMode] = useState(false);

  //Get today date and date after 7 days.
  const date = new Date();
  const dateDefaultValue1 = date.toLocaleDateString("en-CA");

  const futureDate = date.getDate() + 7;
  date.setDate(futureDate);
  const dateDefaultValue2 = date.toLocaleDateString("en-CA");

  // (**) Show Order detail by CustomerID
  const LoadOrderByOrderID = async (orderGUID) => {
    // alert("Load Order by order ID: " + orderGUID);
    console.log("Load Orders Information-------");
    let orderSearched = await orderServices.getOrderInfoByOrderGUID(orderGUID);
    // debugger;
    console.log(
      "searched Order Information is ----------> " + orderSearched.length
    );
    if (
      orderSearched != null &&
      orderSearched !== undefined &&
      orderSearched.length > 0
    ) {
      // alert("got order length" + orderSearched.length);
      // setOrder(orderSearched[0]);
      //  debugger;
      dispatch(addOrderInfo(orderSearched[0]));
      dispatch(updateOrderInfoModeStore(3));
    } else {
      // alert("got order 0" + orderSearched.length);
      //setOrder(null);
      dispatch(updateOrderInfoModeStore(1));
    }
  };

  useEffect(() => {
    LoadOrderByOrderID(props.orderGUID);
  }, [props.orderGUID]);

  //**************    add Order            ***********8 */
  const childSubmitButton = useRef(); // forwardRef(); // useRef(null);

  const changeMode_orderInfo_addview = (modeno) => {
    try {
      // alert("OrderInfo->, modeno :" + modeno);
      dispatch(updateOrderInfoModeStore(modeno));
    } catch (e) {
      console.error(e);
    }
  };

  const AddOrderToDB = async (order) => {
    // debugger;
    // alert(
    //   "save it to DB from parent-> props.customerGUID: " +
    //     ", " +
    //     customerStore.customerID_GUID +
    //     ", " +
    //     props.customerGUID
    // );
    console.log("customerStore : " + customerStore);
    console.log("values : " + order.orderDate);
    order.CustomerID_GUID = customerStore.customerID_GUID; // props.customerGUID;
    let orderSaved = await orderServices.saveOrder(order);
    // setOrder(...order, orderSaved);
    setOrder(orderSaved);
    console.log("OrderSaved:----->> " + orderSaved);
    dispatch(addOrderInfo(orderSaved));
    dispatch(updateOrderInfoModeStore(3));
  };

  const isValidChildFormInputs = (values) => {
    // alert("isValidChildFormInputs at parent");
    console.log("isValidChildFormInputs value : " + values);
  };

  const submitFromModalParent = () => {
    // alert("now submit child");
    childSubmitButton.current.click();
    //this.refs.childComponent.getWrappedInstance().handleSubmit();
  };

  const removeOrder = () => {
    // orderStore.orderID_GUID
    props.removeOrder(orderStore.orderID_GUID);
  };

  //*** end add order */

  const sendSMSOfOrderConfirm = async (orderGUID) => {
    // alert("Send sms of Order: " + orderGUID);
    let orderSMSSent = await orderServices.sendSMSOfOrderConfirm(orderGUID);
    if (orderSMSSent === "null" || orderSMSSent === null) {
      //*** sucessfully send sms */
      //Notification
      NotificationManager.success("SMS send successfully", "Success", 4000);
      dispatch(updateOrder_IsSMSSent(true));
    } else {
      //** failed to send sms */
      //Notification
      NotificationManager.success(orderSMSSent, "Warning", 4000);
    }

    // // setOrder(...order, orderSaved);
    // setOrder(orderSaved);
    // console.log("OrderSaved:----->> " + orderSaved);
    // dispatch(addOrderInfo(orderSaved));
  };

  const openInNewTab = () => {
    if (
      customerStore.customerID_GUID !== "" &&
      orderStore.orderID_GUID !== ""
    ) {
      const win = window.open(
        "/Customer/" +
          customerStore.customerID_GUID +
          "/Order/" +
          orderStore.orderID_GUID,
        "_blank"
      );
      win.focus();
      // history.push("/Measurement/${customerGUID}");
    } else if (
      customerStore.customerID_GUID !== "" &&
      orderStore.orderID_GUID === "addnew"
    ) {
      const win = window.open(
        "/Customer/" + customerStore.customerID_GUID + "/Order/" + "",
        "_blank"
      );
      win.focus();
    } else {
      //Notification
      NotificationManager.success(
        "Customer and Order not found",
        "Warning",
        4000
      );
    }
  };

  return (
    <Fragment>
      {/* printing invoice Block */}
      <div style={{ float: "right", marginRight: "10px" }}>
        <ReactToPrint
          trigger={() => (
            <button className="btn btn-primary px-3">Print Invoice..</button>
          )}
          content={() => printableRef.current}
        />
      </div>
      <div style={{ clear: "both", marginBottom: "10px" }}>&nbsp;</div>

      <div style={{ display: "none" }}>
        <div ref={printableRef}>
          <Invoice
            customerStore={customerStore}
            orderStore={orderStore}
            orderProductItemStore={orderProductItemStore}
          />
        </div>
      </div>

      <div
        className={
          orderInfoModeStore === 3
            ? "media divWithBgColor"
            : "media divWithBgColor_edit"
        }
      >
        <div className="media-body">
          <span className="float-right">
            {" "}
            <div className="btn-group m-b-20">
              {/* <i className="fa-regular fa-diagram-previous"></i> <i className="fa-light fa-browsers"></i> */}

              {(orderInfoModeStore === 1 || orderInfoModeStore === 2) && (
                <button
                  style={{ backgroundColor: "#008000", width: "100px",
                            color:'white'
                   }}
                  id="submitButton"
                  type="submit"
                  onClick={submitFromModalParent}
                  disabled={false}
                  // ref={ref}
                  className="btn btn-light"
                >
                  SAVE
                  {/* <i className="fa fa-save"></i> */}
                </button>
              )}
              {orderInfoModeStore === 3 && (
                <button
                  id="editButton"
                  type="button"
                  disabled={false}
                  onClick={() => {
                    changeMode_orderInfo_addview(2);
                  }}
                  // ref={ref}
                  className="btn btn-light"
                >
                  <i className="fa fa-edit"></i>
                </button>
              )}

              {true && (
                <button
                  className="btn btn-primary px-3"
                  style={{ backgroundColor: "coral" }}
                  id="newTab"
                  type="button"
                  disabled={false}
                  onClick={() => {
                    openInNewTab();
                  }}
                  // ref={ref}
                >
                  <i className="fas fa-send-backward fa-fw"></i>
                  OPEN IN NEW TAB
                </button>
              )}

              <button
                type="button"
                onClick={() => {
                  removeOrder();
                }}
                className="btn btn-light"
              >
                <i className="fa fa-trash"></i>
              </button>
              <button
                className={`btn  px-3 ${
                  orderStore?.isSMSSent ? "" : "btn-primary"
                }`}
                id="newTab"
                type="button"
                disabled={false}
                onClick={() => {
                  sendSMSOfOrderConfirm(orderStore?.orderID_GUID);
                }}
                // ref={ref}
              >
                <i className="fas fa-send-backward fa-fw"></i>
                SEND SMS
              </button>
            </div>
          </span>
          <h4 className="m-0 text-primary">Order Information:</h4>
          <br />
          {/* NOTE: 
          a. if order_GUID has no value then add mode.
          b. if order_GUID has value and isViewMode = false then edit Mode.
          c. if order_GUID has value and isViewMode = true then View mode. */}

          {orderInfoModeStore === 3 && (
            <>
              <div style={{ width: "250px", float: "left" }}>
                {
                  /* <p className="m-b-2">Order Number: {orderStore?.orderNumber}</p> */
                  <p className="m-b-2">Order Number: {orderStore?.orderID}</p>
                }
              </div>
              <div style={{ width: "250px", float: "left" }}>
                <p className="m-b-2">
                  Order Date:{" "}
                  {commonServices.showDateRemovedT(orderStore?.orderDate)}
                </p>
              </div>
              <div style={{ width: "250px", float: "left" }}>
                <p className="m-b-2">
                  Delivery Date:{" "}
                  {commonServices.showDateRemovedT(orderStore?.deliveryDate)}
                </p>
              </div>

              <div style={{ clear: "both" }}></div>

              <div style={{ width: "250px", float: "left" }}>
                <p className="m-b-2">
                  Alertnet Phone no: {orderStore?.alternetPhoneNo}
                </p>
              </div>

              <p className="m-b-2">
                Amount Payable: {orderStore?.amountPayable}
              </p>
            </>
          )}
          {/* else */}
          {(orderInfoModeStore === 1 || orderInfoModeStore === 2) && (
            <OrderAddUpdate
              order={
                orderStore === "undefined" || orderStore === null
                  ? {
                      alternetPhoneNo: "",
                      orderDate: dateDefaultValue1,
                      deliveryDate: dateDefaultValue2,
                    }
                  : orderStore
              }
              isValidChildFormInputs={isValidChildFormInputs}
              AddOrderToDB={AddOrderToDB}
              ref={childSubmitButton}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default OrderDetailInformation;
